import React from 'react';
import { PopperChildrenProps } from 'react-popper';
import { styled } from '@linaria/react';

import '../../styles/theme.css';

const TooltipBackground = styled.div`
  background: var(--bb-bg-tooltip);
  color: var(--bb-color-basic-0);
  padding: 12px 16px;
  font-size: var(--bb-fz-caption);
  line-height: var(--bb-lh-caption);
  border-radius: 3px;
  z-index: 10;
  max-width: 300px;

  b,
  li,
  p {
    color: var(--bb-color-basic-0);
  }
  b {
    display: block;
    margin-bottom: 8px;
  }

  ul {
    margin: 0;
    padding: 0 0 0 14px;
    line-height: 18px;
    line-height: 22px;
    list-style: initial;
  }

  &[data-popper-placement^='top'] > #bb-tooltip-arrow {
    bottom: -4px;
  }

  &[data-popper-placement^='bottom'] > #bb-tooltip-arrow {
    top: -4px;
  }

  &[data-popper-placement^='left'] > #bb-tooltip-arrow {
    right: -4px;
  }

  &[data-popper-placement^='right'] > #bb-tooltip-arrow {
    left: -4px;
  }
`;

const TooltipArrow = styled.div`
  position: absolute;
  width: 8px;
  height: 8px;

  &::before {
    position: absolute;
    width: 8px;
    height: 8px;
    background: var(--bb-bg-tooltip);
    content: '';
    transform: rotate(45deg);
  }
`;

/**
 * TODO: replace all tooltips with unified component
 */

const Tooltip: React.FC<
  {
    children: React.ReactNode;
    tooltipRef: PopperChildrenProps['ref'];
    isActive: boolean;
    className?: string;
  } & Pick<PopperChildrenProps, 'arrowProps' | 'style'>
> = ({ children, tooltipRef, isActive, arrowProps, className, ...props }) => {
  if (isActive) {
    return (
      <TooltipBackground
        {...props}
        ref={tooltipRef}
        className={className}
        id="bb-tooltip"
        role="tooltip"
      >
        {children}
        <TooltipArrow
          {...arrowProps}
          id="bb-tooltip-arrow"
        />
      </TooltipBackground>
    );
  }
  return null;
};

export default Tooltip;
